<template>
  <div class="cost-details-component">
    <div class="text-container">
      <div class="sub-title">
        <span>费用明细</span>
        <span v-if="required" class="star">*</span>
      </div>
      <div class="cost-details">
        <span>
          <i class="el-icon-download"></i>
          从账本导入
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /* 是否必填 */
    required: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
    }
  },

  created() {},

  methods: {
  }
}
</script>

<style lang='scss'>

</style>
